import React from "react";
import { connect } from "react-redux";
import update from "immutability-helper";
import moment from "moment/moment";
import { Panel } from "react-bootstrap";
import TodoTable from "./components/TodoTable";
import TodoSearch from "./components/TodoSearch";
import { getDashboardEvents } from "../../shared/ducks/events";

class TodoDashboard extends React.Component {
  componentWillMount() {
    this.props.actions.loadData(this.props.search);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.dashboardEvents.length !== this.props.dashboardEvents.length
    ) {
      this.fetchData();
    }
  }

  handleChange = e => {
    const search = update(this.props.search, {
      [e.target.name]: { $set: e.target.value }
    });
    this.props.actions.storeSearch(search);
  };

  handleDateChange = name => date => {
    const search = update(this.props.search, {
      [name]: {
        $set: date
      }
    });
    this.props.actions.storeSearch(search);
  };
  
  // handleCheckboxChange = e => {
  //   const search = update(this.props.search, {
  //     [e.target.name]: { $set: e.target.value }
  //   });
  //   this.props.actions.storeSearch(search);
  // };

  handleSubmit = e => {
    e.preventDefault();
    this.fetchData();
  };

  handleReset = () => {
    this.props.actions.storeSearch(this.props.emptySearch);
    this.props.actions.loadData(this.props.emptySearch);
  };

  fetchData = () => {
    const preparedForm = this.prepareFormDataForPost(this.props.search);
    this.props.actions.loadData(preparedForm);
  };

  prepareFormDataForPost = form => {
    return update(form, {
      abnormalityDate: {
        $set: form.abnormalityDate
          ? moment(form.abnormalityDate).format("YYYY-MM-DD")
          : ""
      },
      runDate: {
        $set: form.runDate ? moment(form.runDate).format("YYYY-MM-DD") : ""
      }
    });
  };

  render() {
    const { data, search, isFetching, title } = this.props;

    return (
      <Panel collapsible defaultExpanded header={title}>
        <TodoSearch
          search={search}
          isFetching={isFetching}
          handleChange={this.handleChange}
          handleDateChange={this.handleDateChange}
          handleSubmit={this.handleSubmit}
          handleReset={this.handleReset}
		      // handleCheckboxChange={this.handleCheckboxChange}
        />
        <TodoTable data={data} isFetching={isFetching} />
      </Panel>
    );
  }
}

export default connect(state => ({
  dashboardEvents: getDashboardEvents(state)
}))(TodoDashboard);
